/**
 * Wahl aus wenigen festen Werten als Pillengruppe (Board „Monat je Apartment“): Verfügbarkeit
 * „Unverändert · Freigeben · Blockieren“ und die Beschränkungen „gleich · setzen · aufheben“.
 */
import { cn } from '@/shared/lib/cn';

interface Props<T extends string> {
  label: string;
  options: readonly { value: T; label: string }[];
  value: T;
  onChange: (value: T) => void;
  disabled?: boolean;
  /** Volle Breite mit gleich breiten Feldern. */
  stretch?: boolean;
}

export function SegmentedChoice<T extends string>({
  label,
  options,
  value,
  onChange,
  disabled = false,
  stretch = false,
}: Props<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn('bg-card-alt rounded-pill gap-0.5 p-1', stretch ? 'grid' : 'inline-flex')}
      style={
        stretch ? { gridTemplateColumns: `repeat(${options.length}, minmax(0, 1fr))` } : undefined
      }
    >
      {options.map((option) => {
        const active = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            role="radio"
            aria-checked={active}
            disabled={disabled}
            onClick={() => onChange(option.value)}
            className={cn(
              'rounded-pill h-11 px-3 text-[13px] disabled:opacity-55',
              active ? 'text-ink bg-white font-bold shadow-sm' : 'text-ink-soft font-semibold',
            )}
          >
            {option.label}
          </button>
        );
      })}
    </div>
  );
}
